@if (report) {
  <header class="baer-header">
    @if (reportList) {
      <div class="breadcrumb">
        <a routerLink="/assessments">Assessments</a> &gt;
        <a [routerLink]="'/fire-overview'"
        [queryParams]="{assessment_id: report?.assessment_id}">{{reportList[0]?.assessment?.baer_name}}</a>
        &gt;
        <a [routerLink]="'/fire-overview'"
        [queryParams]="{assessment_id: report?.assessment_id, tab: 2}">Accomplishments</a>
        &gt;
        {{ report?.report_name}}
      </div>
    }
    @if (report) {
      <h1 id="table" class="site-page-title"><span class="large-font">{{report.report_name}}</span></h1>
    }
    @if (report) {
      <div class="status-div">
        Status:
        @if(report.submitted) {
          <mat-chip class="chip-4">
            <span class="chip-text">{{4 | statusBadge}}</span>
          </mat-chip>
        }
        @else {
        <mat-chip class="chip-3">
          <span class="chip-text">{{3 | statusBadge}}</span>
        </mat-chip>
      }
      @if (report.submitted) {
        <span class="spacer">|</span>Submitted on: {{report.submitted_on | date:"MM/dd/yyyy"}}
      }
    </div>
  }
  <div class="button-row">
    <button class="edit-report" (click)="download()">
      <fa-icon class="fa-sm" [icon]="faFileArrowDown"></fa-icon>Export PDF
    </button>
  </div>
</header>
}
@if (report) {
  <div class="report-main">
    @if (report_page != maxPage+1) {
      <div class="report-nav">
        <div class="rnav-header">
          <div>Report Sections</div>
        </div>
        @for (name of pageNames; track name; let page = $index) {
          <div
            [ngClass]="'rnav-item rnav-status-'+(report_page==(page+1) ? (current_status ?? report['page_'+(page+1)+'_status_id']) : report['page_'+(page+1)+'_status_id']) +' rnav-current-'+(report_page==page+1)">
            <button class="anchor-button" (click)="goToPage(page+1)">
              <div>
                @if((report_page==(page+1) && (current_status ?? report['page_'+(page+1)+'_status_id']) == 1) ||
                  (report_page!=(page+1) && report['page_'+(page+1)+'_status_id'] == 1)){
                  <mat-icon class="current-page">contrast</mat-icon>
                }
                @else {
                @if((report_page==(page+1) && (current_status ?? report['page_'+(page+1)+'_status_id']) == 2) ||
                  (report_page!=(page+1) && report['page_'+(page+1)+'_status_id'] == 2)) {
                  <mat-icon>check_circle</mat-icon>
                }
                @else {<mat-icon>panorama_fish_eye</mat-icon>}
              }
              {{page+1}}. {{name}}
            </div>
          </button>
        </div>
        @if (page==1) {
          <div class="sub-menu">
            @for(treatmentType of treatmentTypes; track treatmentType) {
              <div class="rnav-item">
                <button class="anchor-button" (click)="goToPage(page+1, treatmentType.treatment_type_id)">
                  <div>{{treatmentType.treatment_type}}</div>
                </button>
              </div>
            }
          </div>
        }
      }
    </div>
  }
  <div class="report-right-area">
    <div class="report-area">
      <div class="report-section">
        @switch (report_page) {
          @case (1) {@if (reportList) {
            <app-view-accomplishment-details [report]="report" [reportList]="reportList" [(nav)]="nav"
              (status)="statusChange($event)" (loaded)="subLoaded()"
            ></app-view-accomplishment-details>
            }}
            @case (2) {@if (reportList) {
              <app-view-accomplishment-treatments [report]="report" [reportList]="reportList" [(nav)]="nav"
                (status)="statusChange($event)" (loaded)="subLoaded()"
              ></app-view-accomplishment-treatments>
              }}
              @case (3) {@if (reportList) {
                <app-view-accomplishment-additional [report]="report" [reportList]="reportList" [(nav)]="nav"
                  [currentUser]="currentUser" (status)="statusChange($event)"
                (loaded)="subLoaded()"></app-view-accomplishment-additional>
                }}
                @default {<div>No Report Page exists for this ID. please try again. {{report_page}}</div>}
              }
            </div>
          </div>
        </div>
      </div>
    }